export const SALVAGE_TAGS = [
  // MOBILE PHONES & TABLETS
  "Mobile Phones", "Smartphones", "Feature Phones", "Tablets", "E-Readers",
  "Apple iPhone", "Apple iPad", "Samsung Galaxy", "Samsung Galaxy Tab", 
  "Google Pixel", "Huawei", "Xiaomi", "Oppo", "Vivo", "OnePlus", "Nokia", "Sony Xperia", "Motorola", "Honor",
  
  // COMPUTERS & IT
  "Laptops", "Desktop Computers", "All-in-One PCs", "Gaming Laptops", "Business Laptops", "Servers", "Monitors",
  "Apple MacBook", "Apple iMac", "Apple Mac mini", "Dell XPS", "Dell Latitude", "Dell Alienware",
  "HP Spectre", "HP EliteBook", "HP Pavilion", "Lenovo ThinkPad", "Lenovo Yoga", "Lenovo Legion",
  "Asus ROG", "Asus ZenBook", "Acer Predator", "Acer Swift", "MSI Laptops", "Razer Laptops", "Microsoft Surface",
  
  // NETWORKING & OFFICE
  "Networking Equipment", "Routers", "Switches", "Modems", "Access Points",
  "Cisco", "Ubiquiti", "MikroTik", "Netgear", "TP-Link", "Aruba",
  "Printers", "Scanners", "Photocopiers", "Projectors", "POS Systems", "Barcode Scanners",
  "Epson", "Canon Printers", "HP Printers", "Brother", "Lexmark",
  
  // TV, AUDIO & ENTERTAINMENT
  "TVs", "Smart TVs", "OLED TVs", "QLED TVs", "LED TVs", "Home Theatre Systems", "Soundbars",
  "Samsung TVs", "LG TVs", "Sony TVs", "Hisense", "TCL", "Panasonic", "Philips",
  "Gaming Consoles", "Sony PlayStation (PS4/PS5)", "Microsoft Xbox", "Nintendo Switch", "VR Headsets", "Oculus / Meta Quest",
  "Speakers", "Bluetooth Speakers", "Headphones", "Earbuds", "Studio Monitors", "Amplifiers",
  "Bose", "JBL", "Sonos", "Sennheiser", "Sony Audio", "Beats by Dre", "Apple AirPods", "Bowers & Wilkins",
  
  // CAMERAS & DRONES
  "Cameras", "DSLR Cameras", "Mirrorless Cameras", "Point & Shoot", "Action Cameras", "Camcorders",
  "Canon EOS", "Nikon", "Sony Alpha", "Fujifilm", "Panasonic Lumix", "Olympus", "Leica",
  "GoPro", "Insta360", "Drones", "DJI Drones", "Autel Robotics", "Camera Lenses", "Tripods", "Studio Lighting",
  
  // HOUSEHOLD APPLIANCES (WHITE GOODS)
  "Household Appliances", "Refrigerators", "Freezers", "Chest Freezers", "Display Fridges",
  "Washing Machines", "Tumble Dryers", "Dishwashers", "Ovens", "Stoves", "Microwaves", "Extractor Fans",
  "Defy", "Bosch Appliances", "Smeg", "Whirlpool", "LG Appliances", "Samsung Appliances", "Hisense Appliances", "Siemens", "AEG", "Miele",
  
  // SMALL APPLIANCES
  "Small Appliances", "Air Fryers", "Coffee Machines", "Espresso Machines", "Blenders", "Food Processors",
  "Vacuum Cleaners", "Robot Vacuums", "Steam Cleaners", "Irons",
  "Dyson", "Ninja", "NutriBullet", "Nespresso", "Breville", "Kenwood", "Philips Appliances",
  
  // CLIMATE CONTROL
  "Air Conditioners", "Split Unit AC", "Portable AC", "Heaters", "Fans", "Air Purifiers", "Dehumidifiers", "Geysers",
  
  // TOOLS, INDUSTRIAL & COMMERCIAL
  "Power Tools", "Cordless Tools", "Drills", "Grinders", "Saws", "Welders", "Compressors", "Generators", "Pumps",
  "Makita", "DeWalt", "Bosch Professional", "Ryobi", "Milwaukee", "Hilti", "Festool",
  "Manufacturing Machinery", "Workshop Equipment", "Packaging Machines", "Conveyor Equipment",
  
  // SOLAR & POWER BACKUP
  "Solar Panels", "Solar Inverters", "Lithium Batteries", "Deep Cycle Batteries", "UPS Systems", "Electrical Distribution Boards",
  "SunSynk", "Deye", "Victron", "Growatt", "Pylontech", "Hubble Lithium", "Freedom Won",
  
  // HEAVY EQUIPMENT & AGRICULTURE
  "Construction Equipment", "Cement Mixers", "Plate Compactors", "Jackhammers", "Scaffolding",
  "Agricultural Equipment", "Tractors", "Irrigation Systems", "Milking Equipment", "Feed Mixers",
  "Caterpillar", "John Deere", "Massey Ferguson", "New Holland",
  
  // FURNITURE & FIXTURES
  "Furniture", "Lounge Suites", "Couches", "Dining Room Sets", "Beds and Mattresses", "Wardrobes", "Cabinets",
  "Office Furniture", "Office Desks", "Office Chairs", "Filing Cabinets", "Boardroom Tables",
  "Hotel Furniture", "Restaurant Furniture", "Shop Shelving",
  
  // MEDICAL & DENTAL
  "Medical Equipment", "Hospital Beds", "Wheelchairs", "Diagnostic Equipment", "Dental Equipment", "Laboratory Equipment", "Oxygen Concentrators", "Ultrasound Machines", "X-Ray Machines",
  
  // SPORTS, OUTDOOR & LEISURE
  "Sports & Outdoor", "Gym Equipment", "Treadmills", "Stationary Bikes", "Rowing Machines", "Weights",
  "Bicycles", "E-bikes", "Mountain Bikes", "Road Bikes", "Kayaks", "Surfboards", "Camping Equipment", "Tents", "Fishing Gear", "Golf Clubs",
  
  // JEWELLERY, WATCHES & VALUABLES
  "Jewellery", "Rings", "Necklaces", "Bracelets", "Earrings", "Diamonds", "Gold", "Silver", "Platinum",
  "Luxury Watches", "Rolex", "Tag Heuer", "Omega", "Cartier", "Breitling", "Patek Philippe", "Audemars Patek",
  "Coins", "Krugerrands", "Collectibles", "Antiques", "Art",
  
  // RETAIL STOCK & INVENTORY
  "Retail Stock", "Clothing Stock", "Shoes", "Handbags", "Cosmetics", "Perfumes", "Toys", "Sporting Goods Stock", "Books", "Hardware Stock", "Automotive Spares"
];